module.exports = __webpack_public_path__ + "static/media/e23.f6254d61.jpg";